// @flow
import type { SampleList } from "../../lib/OnlineTypes";
import React from "react";
import Samples from "./Samples";
import SampleSearch from "./SampleSearch";
import SampleChargeToolbar from "../invoicing/SampleChargeToolbar";
import SampleActionBar from "./SampleActionBar";

type Props = {
  showUnallocated: ?boolean,
  showOnSentInvoices: ?boolean,
  laboratoryCompanyId: ?number,
  company_id: ?number,
  clientView: ?boolean,
};

export default class SampleChargeSearch extends React.Component<Props, State> {
  static defaultProps = {
    showUnallocated: false,
    showOnSentInvoices: false,
  };

  state = {
    sample_list: null,
    company_id: null,
  };

  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);
    if (this.props.company_id) {
      this.state = {
        company_id: this.props.company_id,
      };
    } else {
      if (urlParams.has("company_id")) {
        this.state = {
          company_id: urlParams.get("company_id"),
        };
      }
    }
  }

  setSampleList = (sample_list: SampleList) =>
    this.setState({
      sample_list,
    });

  render() {
    const {
      showUnallocated,
      showOnSentInvoices,
      laboratoryCompanyId,
      clientView,
    } = this.props;
    const { sample_list, company_id } = this.state;
    return (
      <div>
        <SampleSearch
          ref={(ref) => (this.searcher = ref)}
          company_id={company_id}
          onSearch={this.setSampleList}
          canFindCompany={false}
          clientView={clientView}
          showReceived={false}
          showReviewed={false}
          showContractReviewed={false}
          showCheckboxes={false}
          withUnallocatedSampleCharges={showUnallocated}
          withInvoiceSentSampleLedgerItems={showOnSentInvoices}
          hideCompanySearch={!!company_id}
          dateFilter={showUnallocated ? "first_report_sent_date" : "invoice_sent_date"}
          laboratoryCompanyId={laboratoryCompanyId}
        />
        {sample_list && (
          <div style={{ marginTop: 20 }}>
            <Samples
              sample_list={sample_list}
              clientView={clientView}
              showAttributes={false}
              reloadData={() => this.searcher.findSamples()}
              ToolbarComponent={showUnallocated ? SampleChargeToolbar : SampleActionBar}
              toolbarOptions={{ laboratoryCompanyId: laboratoryCompanyId }}
              viewingSampleCharges
            />
          </div>
        )}
      </div>
    );
  }
}
